module.exports = require("./fr-GA.js");